import { Box, Typography, useTheme } from "@mui/material";
import LoginnewIcon from "../../../../media/images/icons/login-newsvg";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import {
  changeLoginType,
  handleUserLoginTabbar,
} from "../../../../redux/features/settingSlice";

export default function LoginLink() {
  const theme = useTheme();

  const userSignupTab = useAppSelector((state) => state.settings.userSignupTab);

  const dispatch = useAppDispatch();

  return (
    <Box
      sx={{
        marginTop: "24px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: "13px",
          color: "textColor.main",
          fontWeight: "600",
        }}
      >
        قبلا ثبت نام کرده اید؟
      </Typography>

      <Link
        onClick={() => {
          dispatch(changeLoginType("user"));
          dispatch(handleUserLoginTabbar(userSignupTab));
        }}
        to={"/login"}
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.primary.main,
          padding: "4px",
          borderRadius: "8px",
        }}
      >
        <Typography
          sx={{
            fontSize: "13px",
            color: "background.default",
            fontWeight: "600",
          }}
        >
          ورود به برنامه
        </Typography>
        <LoginnewIcon color={theme.palette.background.default} />
      </Link>
    </Box>
  );
}
